import { IPackage } from 'dto/IPackage';

// Funkcja generująca zmockowaną przesyłkę
export const generateMockPackage = (): IPackage => {
  return {
    InternalId: null,
    Type: null,
    TypeId: 1,
    CreationDate: new Date(),
    LastModified: new Date(),
    SendDate: new Date(),
    ReceiveDate: new Date(),
    ReturnDate: null,
    Sender: "Mock Sender",
    //@ts-ignore
    ReceivedBy: [{  Name: "Receiver One" }],
    IsIncoming: true,
    HasTasks: false,
    IsHandled: false,
    IsDeskActive: true,
    IsDraft: false,
    IsSpam: false,
    IsShared: false,
    Unread: true,
    AttachmentsCount: 2,
    TasksCount: 0,
    //@ts-ignore
    Case: null,
    SearchHit: undefined,
    Tasks: null,
    Attachments: [

    ],
    Receivers: [],
    S1: "Sample S1",
    S2: "Sample S2",
    S3: null,
    S4: "Sample S4",
    S5: "Sample S5",
    N1: null,
    N2: null,
    EncryptionKeyId: null,
    IsRemoved: false,
    RemovedDate: null,
    ShowInDossier: 1,
    UserId: "user123",
    ConversationId: null,
    ConversationIndex: null,
    ConversationChilds: null,
    Thread: null,
    CommentsCount: 5,
    state: null,
    //@ts-ignore
    SenderDetails: { Name: "Sender Details" },
    isDelete: false,
    isGotNow: true
  };
};
